import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  openUrl() {
    Turbo.visit(this.data.get("url"));
  }
}
